// SuccessModal.js

import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography
} from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';

// --- Reusing your styles for a consistent look & feel ---

const StyledTitleDialog = styled(DialogTitle)({
    fontFamily: 'BoschSans-Bold',
    display: 'inline-block',
    verticalAlign: 'middle',
    fontWeight: 'bold',
    fontSize: '20px'
});

const StyledMessage = styled(Typography)({
    fontFamily: 'BoschSans',
    fontSize: '16px',
});

const StyledPrimaryButton = styled(Button)({
    border: '1px solid #005691',
    backgroundColor: '#005691 !important',
    color: '#ffffff',
    borderRadius: '0px',
    padding: '8px 35px',
    textTransform: 'none',
    fontFamily: 'BoschSans',
    fontSize: '16px',
    '&:hover': {
        backgroundColor: '#008dcf !important'
    }
});

/**
 * A modal to notify the user of a successful action.
 *
 * @param {object} props
 * @param {boolean} props.open - Whether the dialog is open.
 * @param {function} props.onClose - Function to call when the user clicks the "OK" button.
 * @param {string} props.title - The title for the dialog.
 * @param {string} props.message - The success message to display.
 */
const SuccessModal = ({ open, onClose, title, message }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <Grid container style={{ borderTop: '5px solid #4CAF50' /* Green for success */ }}>
                <Grid item xs={1} style={{ textAlign: 'center', alignSelf: 'center' }}>
                    {/* Success Icon - replace with your actual icon class */}
                    <span
                        className="boschicon-bosch-ic-bookmark-add"
                        style={{ fontSize: '2.5rem', color: '#4CAF50', marginLeft: '1.5rem' }}
                    />
                </Grid>
                <Grid item xs={11}>
                    <StyledTitleDialog>{title || 'Success'}</StyledTitleDialog>
                </Grid>
            </Grid>

            <DialogContent>
                <StyledMessage>
                    {message || 'The action was completed successfully.'}
                </StyledMessage>
            </DialogContent>

            <DialogActions sx={{ padding: '16px 24px' }}>
                <StyledPrimaryButton onClick={onClose}>
                    <span>Ok</span>
                </StyledPrimaryButton>
            </DialogActions>
        </Dialog>
    );
};

export default SuccessModal;
